var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReturnParcel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 45,
    viewBox: "0 0 48 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FA7700"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.148 0L.124 10.27H.039v.144L0 10.48l.04.024V45h47.888V10.525L48 10.48l-.072-.123v-.088h-.052L41.853 0H6.148zm1.25 2.246h33.203l4.707 8.024H2.692L7.4 2.246zM2.245 42.754h43.478V12.516H2.244v30.238z",
    transform: "translate(-165 -1308) translate(165 1308)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.899 35.574L15.204 29.068 35.613 29.068 35.613 26.792 15.209 26.792 21.899 20.288 20.414 18.621 10.839 27.932 20.414 37.241z",
    transform: "translate(-165 -1308) translate(165 1308)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturnParcel);
export default __webpack_public_path__ + "static/media/return-parcel.75428eb6.svg";
export { ForwardRef as ReactComponent };